import React, { useState, useEffect } from 'react';
import { fetchWifiData } from '../data/getdata';
import '../css/SSIDs.css';
import wifiIcon from '../svg/wifi.svg';
import moreIcon from '../svg/more.svg';
import openIcon from '../svg/open.svg';
import securityIcon from '../svg/security.svg';
import FilterSortBar from './FilterSortBar';
import SSIDsDetails from './SSIDsDetails';

const SSIDs = () => {
  const [ssidData, setSSIDData] = useState([]);
  const [otherData, setOTHERData] = useState([]);
  const [selectedSSID, setSelectedSSID] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedData = await fetchWifiData();
        setSSIDData(fetchedData.Detail.ssids);
        setOTHERData(fetchedData.Detail);
      } catch (error) {
        console.error('Error fetching SSID data:', error);
      }
    };

    fetchData();
  }, []);

  const handleSortChange = (option, ascending) => {
    const sortedData = [...ssidData];
    sortedData.sort((a, b) => {
      let aValue = '';
      let bValue = '';

      switch (option) {
        case 'signal_strength':
          aValue = a.signal;
          bValue = b.signal;
          break;
        case 'snr':
          aValue = a.snr;
          bValue = b.snr;
          break;
        case 'ssid':
          aValue = a.ssid ? a.ssid : '[Hidden]';
          bValue = b.ssid ? b.ssid : '[Hidden]';
          break;
        case 'channel_count':
          aValue = a.wifi_item.airwise_active_channels.length;
          bValue = b.wifi_item.airwise_active_channels.length;
          break;
        case 'ap_count':
          aValue = a.wifi_item.aps.length;
          bValue = b.wifi_item.aps.length;
          break;
        default:
          break;
      }

      if (aValue < bValue) {
        return ascending ? -1 : 1;
      }
      if (aValue > bValue) {
        return ascending ? 1 : -1;
      }
      return 0;
    });

    setSSIDData(sortedData);
  };

  const handleSSIDClick = (ssid) => {
    setSelectedSSID(ssid);
    setShowDetails(true);
  };

  const handleReturnClick = () => {
    setShowDetails(false);
    setSelectedSSID(null);
  };

  const getWifiProtocol = (wlan_protocol_set) => {
    let wifiProtocol = '';
    const protocolMap = {
      128: 'ax',
      32: 'ac',
      16: 'n',
      8: 'g',
      4: 'a',
      2: 'b',
    };
    const protocolOrder = [128, 32, 16, 8, 4, 2];

    for (let key of protocolOrder) {
      if (wlan_protocol_set && wlan_protocol_set.includes(key)) {
        wifiProtocol += protocolMap[key] + ', ';
      }
    }

    wifiProtocol = wifiProtocol.trim().replace(/,\s*$/, '');

    return wifiProtocol;
  };

  const getSecurityType = (security_type_set) => {
    if (!security_type_set) return '';

    let securityType = '';
    const securityMap = {
      2048: 'WPA3-P',
      32: 'WPA2-P',
      8: 'WPA-P',
      1: 'OPEN',
    };

    for (let key in securityMap) {
      if (security_type_set.includes(parseInt(key))) {
        securityType += securityMap[key] + ', ';
      }
    }

    securityType = securityType.trim().replace(/,\s*$/, '');

    return securityType;
  };

  const formatLastSeen = (last_seen) => {
    const date = new Date(last_seen);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const amOrPm = hours >= 12 ? '下午' : '上午';
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;
    return `${amOrPm} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  };



    


  useEffect(() => {

    // 根据ID获取匹配的APs列表
    const getMatchedAPs = (aps) => {
      // 确保 otherData 和 aps 都存在
      if (!otherData || !otherData.aps || !aps) return [];
    
      // 遍历所有APs并与otherData中的匹配
      const matchedAPs = aps.filter(ap => otherData.aps.find(item => item.wifi_item.id === ap));
      // 返回匹配的AP的名称列表
      return matchedAPs.map(ap => otherData.aps.find(item => item.wifi_item.id === ap)?.wifi_host.best_name_formatted).filter(Boolean);
    };

    // 根据ID获取匹配的BSSIDs列表
    const getMatchedBSSIDs = (bssids) => {
      // 确保 otherData 和 bssids 都存在
      if (!otherData || !otherData.bssids || !bssids) return [];
    
      // 遍历所有BSSIDs并与otherData中的匹配
      const matchedBSSIDs = bssids.filter(bssid => otherData.bssids.find(item => item.wifi_item.id === bssid));
      // 返回匹配的BSSID的名称列表
      return matchedBSSIDs.map(bssid => otherData.bssids.find(item => item.wifi_item.id === bssid)?.wifi_host.best_name_formatted).filter(Boolean);
    };

    // 定义函数来获取匹配的客户端列表
    const getMatchedClients = (clients) => {
      // 确保 otherData 和 clients 都存在
      if (!otherData || !otherData.clients || !clients) return [];
      
      // 遍历所有客户端并与 otherData 中的匹配
      const matchedClients = clients.filter(client => otherData.clients.find(item => item.wifi_item.id === client));
      // 返回匹配的客户端列表
      return matchedClients.map(client => otherData.clients.find(item => item.wifi_item.id === client)?.wifi_host.best_name_formatted).filter(Boolean);
    };

    ssidData.forEach(ssid => {
      console.log('Wi-Fi状态:', ssid.hidden_state === 'NOT_HIDDEN' ? '广播SSID' : '隐藏SSID');
      console.log('Wi-Fi名称:', ssid.ssid);
      console.log('Wi-Fi支持的协议:', getWifiProtocol(ssid.wifi_item.wlan_protocol_set));
      console.log('Wi-Fi支持的安全类型:', getSecurityType(ssid.wifi_item.security_type_set));
      console.log('信号最强AP:', ssid.strongestApName);
      console.log('信号强度:', ssid.signal, 'dBm');
      console.log('信噪比:', ssid.snr);
      console.log('最后出现时间:', formatLastSeen(ssid.wifi_item.last_seen));
      console.log('关联频段:', ssid.wifi_item.bands === 1 ? '2.4GHz' : '5GHz');
      console.log('关联信道:', ssid.wifi_item.airwise_active_channels.join(', '));
      console.log('关联的AP列表:', getMatchedAPs(ssid.wifi_item.aps).join(', '));
      console.log('关联的BSSID列表:', ssid.wifi_item.bssids ? ssid.wifi_item.bssids.join(', ') : '无');
      console.log('关联的BSSID列表:', getMatchedBSSIDs(ssid.wifi_item.bssids).join(', '));
      console.log('关联客户端:', ssid.wifi_item && ssid.wifi_item.clients ? ssid.wifi_item.clients.join(', ') : '无');
      console.log('关联客户端:', getMatchedClients(ssid.wifi_item.clients).join(', '));
      console.log('----------------------------------------------------');
    });
  }, [ssidData, otherData]); // 注意：这里添加了otherData作为依赖


  
  return (
    <div className="ssid-container">
      <FilterSortBar onSortChange={handleSortChange} />
      {!showDetails && (
        <div className="ssid-list">
          {ssidData.map((ssid, index) => (
            <div key={index} className="ssid-block" onClick={() => handleSSIDClick(ssid)}>
              <img src={wifiIcon} alt="WiFi Logo" className="wifi-icon" />
              <img src={moreIcon} alt="More" className="more-icon" />
              <div className="ssid-name">{ssid.ssid ? ssid.ssid : '[Hidden]'}</div>
              <div className="signal-strength">{ssid.signal} dBm</div>
              <div className="ap-count">APs: {ssid.wifi_item.aps.length}</div>
              <div className="ssid-value">
                {ssid.ssid ? ssid.ssid : '[Hidden]'}
              </div>
              <img src={ssid.wifi_item.security_type === 'WLAN_SECURITY_OPEN' ? openIcon : securityIcon} alt="Security" className="security-icon" />
            </div>
          ))}
        </div>
      )}
      {showDetails && selectedSSID && (
        <div className="ssid-details">
          <SSIDsDetails selectedSSID={selectedSSID} otherData={otherData} onReturn={handleReturnClick} />
        </div>
      )}
    </div>
  );
};

export default SSIDs;
